import { render, staticRenderFns } from "./PosReceipts.vue?vue&type=template&id=0501ee9c&scoped=true"
import script from "./PosReceipts.vue?vue&type=script&lang=js"
export * from "./PosReceipts.vue?vue&type=script&lang=js"
import style0 from "./PosReceipts.vue?vue&type=style&index=0&id=0501ee9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0501ee9c",
  null
  
)

export default component.exports